import { render, staticRenderFns } from "./newParentStore.vue?vue&type=template&id=52ee7782"
import script from "./newParentStore.vue?vue&type=script&lang=js"
export * from "./newParentStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports